import React from "react";
import CustodiesContent from "../../Component/CustodiesContent/CustodiesContent";


function Employees() {
  return <CustodiesContent />
      
}

export default Employees;
